// extracted by mini-css-extract-plugin
export default {"deleteCategoryWarningText":"Ax1flQUYAO"};